<template>
  <div class="Autocomplete__Wrapper">
    <MaterialInput
      type="text"
      class="city-form-group city-bg"
      id="input-code"
      name="code"
      v-model.trim="searchTerm"
      v-bind="$attrs"
      :id="mdInputId"
      :name="mdInputName"
      :maxlength="mdInputMaxlength"
      :placeholder="$t(mdInputPlaceholder)"
      @focus.stop="openOnFocus"
      @blur="hideOptions"
      @input="onInput"
      @click.stop.prevent="openOnFocus"
    ><slot />
      </MaterialInput>
  </div>
</template>

<script type="text/javascript">

  export default {
    name: 'material-autocomplete',
    props: {
      value: {
        type: null,
        required: true
      },
      mdDense: Boolean,
      mdLayout: {
        type: String,
        default: 'floating',
      },
      mdOpenOnFocus: {
        type: Boolean,
        default: true
      },
      mdFuzzySearch: {
        type: Boolean,
        default: true
      },
      mdOptions: {
        type: [Array, Promise],
        required: true
      },
      mdInputName: String,
      mdInputId: String,
      mdInputMaxlength: [String, Number],
      mdInputPlaceholder: [String, Number],
    },
    data() {
      return {
        searchTerm: this.value,
        showMenu: false,
        triggerPopover: false,
        isPromisePending: false,
        filteredAsyncOptions: []
      };
    },
    computed: {
      shouldFilter () {
        return this.mdOptions[0] && this.searchTerm
      },
      filteredStaticOptions () {
        if (this.isPromise(this.mdOptions)) {
          return false
        }
        const firstItem = this.mdOptions[0]
        if (this.shouldFilter) {
          if (typeof firstItem === 'string') {
            return this.filterByString()
          } else if (typeof firstItem === 'object') {
            return this.filterByObject()
          }
        }
        return this.mdOptions
      },
      hasFilteredItems () {
        return this.filteredStaticOptions.length > 0 || this.filteredAsyncOptions.length > 0
      },
      hasScopedEmptySlot () {
        return this.$scopedSlots['md-autocomplete-empty']
      }
    },
    watch: {

    },
    methods: {
      getOptions () {
        if (this.isPromise(this.mdOptions)) {
          return this.filteredAsyncOptions
        }
        return this.filteredStaticOptions
      },
      isPromise (obj) {
        return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
      },
      matchText (item) {
        const target = item.toLowerCase()
        const search = this.searchTerm.toLowerCase()
        if (this.mdFuzzySearch) {
          return fuzzy(search, target)
        }
        return target.includes(search)
      },
      filterByString () {
        return this.mdOptions.filter(item => this.matchText(item))
      },
      filterByObject () {
        return this.mdOptions.filter(item => {
          const values = Object.values(item)
          const valuesCount = values.length
          for (let i = 0; i <= valuesCount; i++) {
            if (typeof values[i] === 'string' && this.matchText(values[i])) {
              return true
            }
          }
        })
      },
      openOnFocus () {
        if (this.mdOpenOnFocus) {
          this.showOptions()
        }
      },
      onInput (value) {
        this.$emit('input', value)
        if (!this.mdOpenOnFocus) {
          this.showOptions()
        }
        if (this.searchTerm.constructor.toString().match(/function (\w*)/)[1].toLowerCase() !== 'inputevent') {
          this.$emit('md-changed', this.searchTerm)
        }
      },
      showOptions () {
        if (this.showMenu) {
          return false
        }
        this.showMenu = true
        this.$nextTick(() => {
          this.triggerPopover = true
          this.$emit('md-opened')
        })
      },
      hideOptions () {
        this.$nextTick(() => {
          this.triggerPopover = false
          this.$emit('md-closed')
        })
      },
      selectItem (item, $event) {
        const content = $event.target.textContent.trim()
        this.searchTerm = content
        this.$emit('input', item)
        this.$emit('md-selected', item)
        this.hideOptions()
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>